import React from "react";

export default function SlopeBlack(props: any) {
  return (
    <svg className="map-slope-icon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" {...props}>
      <rect x="20.4" y="20.4" width="59.21" height="59.21" transform="translate(50 -20.71) rotate(45)"></rect>
    </svg>
  );
}